import { ConfigRecord } from "./ConfigRecord"
import { LightColorsAndShow } from "../../catalog/documents/LightCatalog";

export type PaletteRecord = ConfigRecord<PaletteConfig>;
export class PaletteConfig {
  colors:CustomColor[] = [];
};

export class CustomColor {
  uuid:string;
  name:string;
  colors:LightColorsAndShow[] = [];
  isShow:boolean = false;
}